module.exports = __webpack_public_path__ + "img/contacts.42354d53.svg";